var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75601 0.49654C1.56082 0.301213 1.24424 0.301107 1.04891 0.496304C0.853581 0.691501 0.853475 1.00808 1.04867 1.20341L1.75601 0.49654ZM3.70081 3.14998L3.34714 3.50341L3.70081 3.85732L4.05448 3.50341L3.70081 3.14998ZM6.35295 1.20341C6.54815 1.00808 6.54804 0.691501 6.35271 0.496304C6.15739 0.301107 5.8408 0.301213 5.64561 0.49654L6.35295 1.20341ZM1.04867 1.20341L3.34714 3.50341L4.05448 2.79654L1.75601 0.49654L1.04867 1.20341ZM4.05448 3.50341L6.35295 1.20341L5.64561 0.49654L3.34714 2.79654L4.05448 3.50341Z",
    fill: "#867586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrowButton);
export default __webpack_public_path__ + "static/media/dropDownArrowButton.572273266475cbbfdaa9ab47be3c5f8d.svg";
export { ForwardRef as ReactComponent };